import { render, staticRenderFns } from "./WsEmptyAddCard001.vue?vue&type=template&id=a8b2a79e"
import script from "./WsEmptyAddCard001.vue?vue&type=script&lang=js"
export * from "./WsEmptyAddCard001.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports